export const getIndustryAccountIdBySource = (source) => {
  const industries = {
    AMBEV: '620f83a49a0292e3a28c1729',
  }

  return industries[source]
}
